import React, { Component } from 'react';
import '../assets/googleradio.css';
import { cx } from '@emotion/css';
import * as styles from './newQuestionBox.style';
import { title } from './questionWithTextFeild.style';
import QuizIndicator from './QuizIndicator';
import withQuizPic from './hoc/withQuizPic';
import * as styles1 from './questionWithTextFeild.style';

class TexttoSpeechwithRadioButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answer: '',
      quizPic: this.props.getRandomImage(1),
      showmeaning: false,
      meaning: '',
    };
    this.handleRadioChange = this.handleRadioChange.bind(this);

    // Initial speech of the word when component mounts
    const utterance = new window.SpeechSynthesisUtterance();
    const word = this.props.word_to_pronounce;
    utterance.text = word;
    utterance.lang = this.props.subcategory === 'Spanish' ? 'es-US' : 'en-US';
    window.speechSynthesis.speak(utterance);
  }

  uttertext_GB = () => {
    const utterance = new window.SpeechSynthesisUtterance();
    const word = this.props.word_to_pronounce;
    utterance.text = word;
    utterance.lang = this.props.subcategory === 'Spanish' ? 'es-ES' : 'en-GB';
    window.speechSynthesis.speak(utterance);
  };

  uttertext_US = () => {
    const utterance = new window.SpeechSynthesisUtterance();
    const word = this.props.word_to_pronounce;
    utterance.text = word;
    utterance.lang = this.props.subcategory === 'Spanish' ? 'es-US' : 'en-US';
    window.speechSynthesis.speak(utterance);
  };

  getMp3fromdictionary = () => {
    const audio = new Audio(this.props.audio);
    audio.play();
  };

  tellMeaning = () => {
    this.setState({ meaning: this.props.meaning, showmeaning: true });
  };

  handleRadioChange(event) {
    this.setState({
      answer: event.target.value,
    });
  }

  selectedanswer = (answer, id) => {
    this.props.selected(answer, id);
  };

  componentDidMount() {
    this.setState({
      answer: this.props.selectedanswer1,
      quizPic: this.props.getRandomImage(this.props.questionnumber),
    });
  }

  render() {
    return (
      <div className={cx(styles.multiChoice)}>
        <div className="leftpanel">
          <h2 className={cx(title)}>
            <span>Q{this.props.questionnumber}/</span>
            {this.props.questionCount}
          </h2>
          <img className="quiz-img" src={this.state.quizPic} alt="" />
          <div className="s-title">{this.props.question}</div>
          <QuizIndicator
            className="mb-0"
            questionCount={this.props.questionCount}
            questionnumber={this.props.questionnumber}
          />
          <div>
            <div className={cx(styles1.iconGroup)}>
              <img
                src="../assets/redphone.png"
                alt=""
                className="card1-img-top"
                onClick={this.uttertext_US}
              />
              <img
                src="../assets/bluephone.png"
                alt=""
                className="card1-img-top"
                onClick={this.uttertext_GB}
              />

              {this.props.category === "Spelling Bowl" && this.props.audio && (
                <img
                  src="../assets/red_megaphone.png"
                  alt=""
                  className="card1-img-top"
                  onClick={this.getMp3fromdictionary}
                />
              )}

              {this.props.category === "Spelling Bowl" && (
                <img
                  src="../assets/bulb.png"
                  alt=""
                  className="card1-img-top"
                  onClick={() =>
                    this.tellMeaning()
                  }
                />
              )}
            </div>
          </div>
        </div>
        <div className="rightpanel">
          <p className="s-title">Select Answer Below </p>
          {this.props.answer.map((text, index) => (
            <label className={cx(styles.input)} key={index}>
              <div id={this.props.id + index}>
                <input
                  type="radio"
                  key={this.props.id + index}
                  value={text}
                  name={this.props.id}
                  checked={this.state.answer === text}
                  className="radiobutton"
                  onChange={this.handleRadioChange}
                  onClick={() => {
                    this.props.selected(text, this.props.id);
                  }}
                />
                {this.props.category === 'Flags' ? (
                  <div className="flags">{' ' + text}</div>
                ) : (
                  <div className="">{'  ' + text}</div>
                )}
              </div>
            </label>
          ))}
          <div className="btn-group">{this.props.controlButtons}</div>
        </div>
      </div>
    );
  }
}

export default withQuizPic(TexttoSpeechwithRadioButton);